import React, { useEffect, useState } from "react";
import appStore from "../../assets/app-store.svg";
import googleStore from "../../assets/google-play.svg";

function FooterStores() {
    const [platform, setPlatform] = useState("desktop"); // default to desktop => both

    useEffect(() => {
        const detectPlatform = () => {
            if (typeof navigator === "undefined") return "desktop";

            const ua = navigator.userAgent || navigator.vendor || window.opera;

            const isIOS =
                /iPad|iPhone|iPod/.test(ua) ||
                (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

            if (isIOS) return "ios";
            if (/Android/i.test(ua)) return "android";

            return "desktop";
        };

        setPlatform(detectPlatform());
    }, []);

    return (
        <div className="store-icons">
            {(platform === "ios" || platform === "desktop") && (
                <a href="https://apps.apple.com/us/app/etransport-lt/id1062673660">
                    <img className="badge" src={appStore} alt="App Store" id="apple-store" />
                </a>
            )}

            {(platform === "android" || platform === "desktop") && (
                <a href="https://play.google.com/store/apps/details?id=com.eTransport.LT.taxi1424">
                    <img
                        className="badge"
                        src={googleStore}
                        alt="Google Play"
                        id="google-play"
                    />
                </a>
            )}
        </div>
    );
}

export default FooterStores;
